import { observable, computed, action, makeObservable } from 'mobx';

import { PatientListModel } from './PatientListModel';
import { SearchPatientList } from '@patient/store/patient/SearchPatientList';

export abstract class PatientStoreModel<E extends { id: string }> {
    @observable public abstract patientList: PatientListModel;
    @observable public abstract lastViewPatientList: PatientListModel;
    @observable public abstract searchList: SearchPatientList;
    @observable protected similarEhrs = new Map<string, E[]>();

    constructor() {
        makeObservable(this);
    }

    @computed
    public get query(): string {
        const { query = '' } = this.searchList.searchParams;
        return query;
    }

    public isSimilarEhrsLoaded(ehrId: string): boolean {
        return this.similarEhrs.has(ehrId);
    }

    @action
    public setSimilarEhrsLoaded(ehrId: string, similarEhrs: E[]): void {
        this.similarEhrs.set(
            ehrId,
            similarEhrs.filter(({ id }) => id !== ehrId),
        );
    }

    public getSimilarEhrs(ehrId: string): E[] {
        return this.similarEhrs.get(ehrId) || [];
    }

    public hasSimilarEhrs(ehrId: string): boolean {
        return this.getSimilarEhrs(ehrId).length > 0;
    }
}
